import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { UpdatePrompt } from './pwa.jsx';
import { router } from './router.jsx';
import { SessionProvider } from './session.jsx';
import { ThemeProvider } from './theme/use-theme.jsx';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <SessionProvider>
        <RouterProvider router={router} />
      </SessionProvider>
    </ThemeProvider>
    <UpdatePrompt />
  </StrictMode>,
);
